import { Apollo_gql, GraphQueryPayload } from '@camelot/server';

import { dynamicTranslationProps } from './dto/dynamic-translation';

export function GET_DYNAMIC_TRANSLATION(lang: string, tenantId: number): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query DynamicTranslations($filters: TranslationsDynamictranslationFiltersInput!) {
        translationsDynamictranslations(filters: $filters, pagination: { pageSize: 50000 }) {
          ${dynamicTranslationProps.get('documentId')}
          ${dynamicTranslationProps.get('key')}
          ${dynamicTranslationProps.get('value')}
        }
      }
    `,
    variables: {
      filters: { transKey: { eq: lang }, partner: { UID: { eq: tenantId.toString() } } },
    },
  };
}
